/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTeamRequest
 */
export interface CreateTeamRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof CreateTeamRequest
     */
    readonly $schema?: string;
    /**
     * Team Basket API ID
     * @type {number}
     * @memberof CreateTeamRequest
     */
    basketApiId: number;
    /**
     * Team CBBD API ID
     * @type {number}
     * @memberof CreateTeamRequest
     */
    cbbdApiId: number;
    /**
     * Team ESPN ID
     * @type {number}
     * @memberof CreateTeamRequest
     */
    espnId: number;
    /**
     * Team external URL, link to their athletics website
     * @type {string}
     * @memberof CreateTeamRequest
     */
    externalUrl: string;
    /**
     * Name of the season
     * @type {string}
     * @memberof CreateTeamRequest
     */
    name: string;
    /**
     * Team NCAA SEO
     * @type {string}
     * @memberof CreateTeamRequest
     */
    ncaaSeo: string;
    /**
     * Team primary color
     * @type {string}
     * @memberof CreateTeamRequest
     */
    primaryColor: string;
    /**
     * Team secondary color
     * @type {string}
     * @memberof CreateTeamRequest
     */
    secondaryColor: string;
    /**
     * Team short name
     * @type {string}
     * @memberof CreateTeamRequest
     */
    shortName: string;
}

/**
 * Check if a given object implements the CreateTeamRequest interface.
 */
export function instanceOfCreateTeamRequest(value: object): value is CreateTeamRequest {
    if (!('basketApiId' in value) || value['basketApiId'] === undefined) return false;
    if (!('cbbdApiId' in value) || value['cbbdApiId'] === undefined) return false;
    if (!('espnId' in value) || value['espnId'] === undefined) return false;
    if (!('externalUrl' in value) || value['externalUrl'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ncaaSeo' in value) || value['ncaaSeo'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    return true;
}

export function CreateTeamRequestFromJSON(json: any): CreateTeamRequest {
    return CreateTeamRequestFromJSONTyped(json, false);
}

export function CreateTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'basketApiId': json['basket_api_id'],
        'cbbdApiId': json['cbbd_api_id'],
        'espnId': json['espn_id'],
        'externalUrl': json['external_url'],
        'name': json['name'],
        'ncaaSeo': json['ncaa_seo'],
        'primaryColor': json['primary_color'],
        'secondaryColor': json['secondary_color'],
        'shortName': json['short_name'],
    };
}

export function CreateTeamRequestToJSON(json: any): CreateTeamRequest {
    return CreateTeamRequestToJSONTyped(json, false);
}

export function CreateTeamRequestToJSONTyped(value?: Omit<CreateTeamRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basket_api_id': value['basketApiId'],
        'cbbd_api_id': value['cbbdApiId'],
        'espn_id': value['espnId'],
        'external_url': value['externalUrl'],
        'name': value['name'],
        'ncaa_seo': value['ncaaSeo'],
        'primary_color': value['primaryColor'],
        'secondary_color': value['secondaryColor'],
        'short_name': value['shortName'],
    };
}

